import jwtAuthAxios from "../auth/jwtAuth";
import jwtAuthKioskAxios from "../auth/jwtAuthKiosk";
import { setAuthBackendDomain, setBackendDomain } from "./management";

export const getMenu = async (url, customerId) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `/restaurant-menu/get?url=${url}&customerId=${customerId}`
  );
  return data.response;
};

export const getMenus = async (customerId) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `/restaurant-menu/list?customerId=${customerId}`
  );
  return data.response && data.response.filter(({ type }) => type === "menu");
};

export const getDsokMenus = async () => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.get(`/api/v1/menu`);
  return data?.data?.data;
};

export const getDsokDashboardStats = async () => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.get(`/api/v1/dashboard/stats`);
  return data?.data;
};

export const getDsokYearSummary = async () => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.get(`/api/v1/dashboard/orders`);
  return data?.data;
};

export const getDsokMenu = async (code) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.get(`/api/v1/menu/id/${code}`);
  return data?.data?.data;
};

export const addDsokMenu = async (menu) => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.post(`/api/v1/menu`, menu);
  // Backend may return menu at data.data.data (like getDsokMenu) or data.data or data
  const created = data?.data?.data ?? data?.data ?? data;
  return created;
};

export const deleteDsokMenu = async (code) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.delete(`/api/v1/menu/${code}`);
  return data?.data;
};

export const addMenu = async (customerId, menu) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post("/restaurant-menu/add", {
    customerId,
    ...menu,
    type: "menu",
  });
  return data.url;
};

export const updateDsokMenu = async (menu) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.put(`/api/v1/menu/id/${menu._id}`, menu);
  return data?.data;
};

export const editMenu = async (customerId, menu) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post("/restaurant-menu/update", {
    ...menu,
    customerId,
    type: "menu",
  });
  return data;
};

export const deleteMenu = async (url, customerId) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.delete(
    `/restaurant-menu/delete?url=${url}&customerId=${customerId}`
  );
  return data;
};

export const getRemoteControlMenu = async (
  url,
  customerId,
  username,
  password
) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    `/menu-get?url=${url}&customerId=${customerId}&username=${username}&password=${password}`
  );
  return data.response;
};

export const updateRemoteControlMenu = async (customerId, menu) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post("/menu-update", {
    ...menu,
    customerId,
    type: "menu",
  });
  return data;
};

export const updateRemoteControlOffer = async (customerId, menu) => {
  setAuthBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post("/menu-update", {
    ...menu,
    customerId,
    type: "menu",
  });
  return data;
};
